import { render, staticRenderFns } from "./PowerOfAttorney.vue?vue&type=template&id=73409c95&scoped=true"
import script from "./PowerOfAttorney.vue?vue&type=script&lang=js"
export * from "./PowerOfAttorney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73409c95",
  null
  
)

export default component.exports